import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
  customersDocumentType,
  chileanBankAccountType,
  peruvianBankAccountType,
  customersBankAccountType,
  argentinianBankAccountType,
  mexicanCustomersDocumentType,
  chileanCustomersDocumentType,
  peruvianCustomersDocumentType,
  argentinianCustomersDocumentType,
  brazilianCustomersDocumentType,
  brazilianBankAccountType
} from '../../lib/common.lib'
import { Customer, BankAccount } from '../../types'
import EditIcon from '../../assets/icons/edit-icon.svg'
import BankIconNeutral from '../../assets/icons/bank-icon-neutral.svg'
import ContactsIconNeutral from '../../assets/icons/contacts-icon-neutral.svg'
import { baseButtonBlueBg, baseButtonTextWhiteBg } from '../../theme/custom-styles'

const CustomerDetailsMainData = ({
  customerData,
  customerMainBankAccountData,
  handleOpenNewBankAccountDialog,
  handleGoToBanksAccountsManagement
}: {
  customerData: Customer
  handleOpenNewBankAccountDialog: () => void
  handleGoToBanksAccountsManagement: () => void
  customerMainBankAccountData: Partial<BankAccount>
}) => {
  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'

  const { t } = useTranslation(['customer-details-management'])

  return (
    <div className="customer-details-profile-main-data">
      <div className="customer-details-profile-customer-name">{customerData?.registeredFullName || t('customerDetailsMainData.loading')}</div>
      <div className="customer-details-profile-customer-identification">
        <div className="customer-details-profile-customer-identification-item">
          <div className="customer-details-profile-customer-identification-item-title">
            <div className="customer-details-profile-customer-identification-item-title-icon">
              <img
                src={ContactsIconNeutral}
                alt="contacts-icon-neutral"
              />
            </div>
            <div className="customer-details-profile-customer-identification-item-title-text">{t('customerDetailsMainData.documentType')}</div>
          </div>
          {selectedCountry === 'COL' && (
            <div className="customer-details-profile-customer-identification-item-data">{(customersDocumentType as any)[customerData?.documentType ?? 'C'] || t('customerDetailsMainData.loading')}</div>
          )}
          {selectedCountry === 'ARG' && (
            <div className="customer-details-profile-customer-identification-item-data">
              {(argentinianCustomersDocumentType as any)[customerData?.documentType?.toLowerCase() || 'dni'] || t('customerDetailsMainData.loading')}
            </div>
          )}
          {selectedCountry === 'CHI' && (
            <div className="customer-details-profile-customer-identification-item-data">
              {(chileanCustomersDocumentType as any)[customerData?.documentType?.toLowerCase() || 'rut'] || t('customerDetailsMainData.loading')}
            </div>
          )}
          {selectedCountry === 'PER' && (
            <div className="customer-details-profile-customer-identification-item-data">
              {(peruvianCustomersDocumentType as any)[customerData?.documentType?.toLowerCase() || 'dni'] || t('customerDetailsMainData.loading')}
            </div>
          )}
          {selectedCountry === 'BRA' && (
            <div className="customer-details-profile-customer-identification-item-data">
              {(brazilianCustomersDocumentType as any)[customerData?.documentType?.toLowerCase() || 'cpf'] || t('customerDetailsMainData.loading')}
            </div>
          )}
          {selectedCountry === 'MEX' && (
            <div className="customer-details-profile-customer-identification-item-data">{(mexicanCustomersDocumentType as any)[customerData?.documentType || 'curp'] || t('customerDetailsMainData.loading')}</div>
          )}
        </div>
        <div className="customer-details-profile-customer-identification-item">
          <div className="customer-details-profile-customer-identification-item-title">
            <div className="customer-details-profile-customer-identification-item-title-icon">
              <img
                src={ContactsIconNeutral}
                alt="contacts-icon-neutral"
              />
            </div>
            <div className="customer-details-profile-customer-identification-item-title-text">{t('customerDetailsMainData.documentNumber')}</div>
          </div>
          <div className="customer-details-profile-customer-identification-item-data">{customerData.documentNumber || t('customerDetailsMainData.loading')}</div>
        </div>
      </div>
      <div className="customer-details-profile-customer-identification">
        <div className="customer-details-profile-customer-identification-item">
          <div className="customer-details-profile-customer-identification-item-title">
            <div className="customer-details-profile-customer-identification-item-title-icon">
              <img
                src={BankIconNeutral}
                alt="bank-icon-neutral"
              />
            </div>
            <div className="customer-details-profile-customer-identification-item-title-text">{t('customerDetailsMainData.bankAccount')}</div>
          </div>
          <div className="customer-details-profile-customer-identification-item-data">
            {selectedCountry === 'COL' && (
              <div className="customer-details-profile-customer-bank-account-item-data">
                {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
                  <>{`${(customersBankAccountType as any)[customerMainBankAccountData?.bankAccountType ?? '2']} ${customerMainBankAccountData?.bankName} - No. ${customerMainBankAccountData?.bankNumber}`}</>
                ) : (
                  <>{t('notBankAccountsSet')}</>
                )}
              </div>
            )}
            {selectedCountry === 'MEX' && (
              <div className="customer-details-profile-customer-bank-account-item-data">
                {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
                  <>{`${customerMainBankAccountData?.bankAccountType?.toUpperCase()} ${customerMainBankAccountData?.bankName || ''} - No. ${customerMainBankAccountData?.bankNumber}`}</>
                ) : (
                  <>{t('notBankAccountsSet')}</>
                )}
              </div>
            )}
            {selectedCountry === 'ARG' && (
              <div className="customer-details-profile-customer-bank-account-item-data">
                {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
                  <>{`${(argentinianBankAccountType as any)[customerMainBankAccountData?.bankAccountType || 'savings'].toUpperCase()} - ${customerMainBankAccountData?.bankName} - No. ${customerMainBankAccountData?.bankNumber}`}</>
                ) : (
                  <>{t('notBankAccountsSet')}</>
                )}
              </div>
            )}
            {selectedCountry === 'BRA' && (
              <div className="customer-details-profile-customer-bank-account-item-data">
                {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
                  <>{`${(brazilianBankAccountType as any)[customerMainBankAccountData?.bankAccountType || 'savings'].toUpperCase()} - ${customerMainBankAccountData?.bankName} - No. ${customerMainBankAccountData?.bankNumber}`}</>
                ) : (
                  <>{t('notBankAccountsSet')}</>
                )}
              </div>
            )}
            {selectedCountry === 'CHI' && (
              <div className="customer-details-profile-customer-bank-account-item-data">
                {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
                  <>{`${(chileanBankAccountType as any)[customerMainBankAccountData?.bankAccountType || 'savings'].toUpperCase()} - ${customerMainBankAccountData?.bankName} - No. ${customerMainBankAccountData?.bankNumber}`}</>
                ) : (
                  <>{t('notBankAccountsSet')}</>
                )}
              </div>
            )}
            {selectedCountry === 'PER' && (
              <div className="customer-details-profile-customer-bank-account-item-data">
                {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
                  <>{`${(peruvianBankAccountType as any)[customerMainBankAccountData?.bankAccountType || 'savings'].toUpperCase()} - ${customerMainBankAccountData?.bankName} - No. ${customerMainBankAccountData?.bankNumber}`}</>
                ) : (
                  <>{t('notBankAccountsSet')}</>
                )}
              </div>
            )}
            <div className="customer-details-profile-customer-bank-account-action-buttons-container">
              {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 1 ? (
                <Button
                  variant="text"
                  sx={baseButtonTextWhiteBg}
                  className="users-management-actions-bar-button-action"
                  onClick={handleGoToBanksAccountsManagement}
                >
                  <div className="users-management-actions-bar-button-action-text">{t('customerDetailsMainData.buttonsTexts.showMore', { bankAccountsDataLength: customerData.bankAccountsData.length - 1 })}</div>
                </Button>
              ) : (
                Array.isArray(customerData.bankAccountsData) &&
                customerData.bankAccountsData.length > 0 && (
                  <div
                    onClick={handleGoToBanksAccountsManagement}
                    className="customer-details-profile-customer-bank-account-edit-button-container"
                  >
                    <img
                      src={EditIcon}
                      alt="edit-icon"
                    />
                  </div>
                )
              )}
              <Button
                variant="contained"
                sx={baseButtonBlueBg}
                onClick={handleOpenNewBankAccountDialog}
                className="customer-details-profile-customer-bank-account-add-button"
              >
                <div className="customer-details-profile-customer-bank-account-add-button-text">{t('customerDetailsMainData.buttonsTexts.addBankAccount')}</div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerDetailsMainData
